"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const version = "2.7.3";
exports.version = version;
//# sourceMappingURL=package.json.cjs.map
